import React from "react"
import DropdownBox from "./DropdownBox"
import { getCounties, selectCountiesAsArray } from "data/counties"
import { connect } from "react-redux"
import SearchField from "./SearchField"
import styles from "./styles.scss"
import { searchResultsPath, companySearchPath } from "utils/paths"
import { withRouter } from "react-router"

class SearchBarWrapper extends React.Component {
  state = {
    selectedCounty: {},
    countyIsSet: true,
  }

  handleSelectCounty = county => {
    const { onSelectCounty } = this.props

    this.setState({ selectedCounty: county, countyIsSet: false })

    onSelectCounty && onSelectCounty(county)
  }

  handleSearch = search => {
    if (search.value) {
      const county = JSON.parse(localStorage.getItem("County"))
      search.type === "categories"
        ? this.props.history.push(
            searchResultsPath(county.id, search.value)
          )
        : this.props.history.push(companySearchPath(search.value))
    }
  }

  componentDidMount() {
    this.props.getCounties()

    this.setState({
      countyIsSet: localStorage.getItem("County") ? false : true,
    })
  }

  render() {
    return (
      <div className={styles.container}>
        <DropdownBox
          onSelectCounty={this.handleSelectCounty}
          list={this.props.counties}
        />
        <SearchField
          onSearch={this.handleSearch}
          placeholder="Sök efter tjänst eller företag..."
          countyIsSet={this.state.countyIsSet}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  counties: selectCountiesAsArray(state, ownProps),
})
export default withRouter(
  connect(mapStateToProps, {
    getCounties,
  })(SearchBarWrapper)
)



// WEBPACK FOOTER //
// src/components/SearchBarWrapper/index.jsx